import {getListeners} from './store'

export default async function(name, data) {
  const listeners = getListeners(name)

  for (const listener of listeners) {
    await listener(data)
  }
}
